import { Sidebar } from 'components/Sidebar/Sidebar';
import React from 'react';
import { useLocation } from 'react-router-dom';

import './AdminMobileView.scss';
import { AdminHeader } from 'components/Headers/AdminHeader/AdminHeader';
import { useViewVM } from '../useViewVM';

export type AdminMobileViewProps = {
    render: React.ReactNode;
    headerTitle?: string;
    backButton?: boolean;
    backButtonLink?: string;
};

export const AdminMobileView: React.FC<AdminMobileViewProps> = ({ render, headerTitle = '', backButton = false, backButtonLink = "" }) => {
    const location = useLocation();

    // Fonction pour obtenir le nom de la page à partir de l'URL
    const getPageNameFromPath = () => {
        const path = location.pathname;
        const segments = path.split('/');
        const lastSegment = segments[segments.length - 1];

        // Gestion des cas spéciaux
        if (lastSegment === 'admin') return 'dashboard';
        if (lastSegment === 'persons' && path.includes('new')) return 'new-person';
        if (segments.includes('persons') && segments.length > 4) return 'person-details';

        return lastSegment;
    };

    const pageClassName = getPageNameFromPath();

    const { } = useViewVM({ render });
    return (
        <>
            <div className={`admin-mobile ${pageClassName}`}>
                {render}
            </div>
        </>
    );
};
